import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useNotificationState() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.notificationState, ...args };
    updateGlobalState({ notificationState: newState });
  };

  const setNotification = (args) => setState({ ...args, isPresent: true });

  const clearNotification = () => setState({ isPresent: false });

  return { clearNotification, setNotification, state: state.notificationState };
}
